module.exports = __webpack_public_path__ + "img/zg_63.prt.dcea1142.jpg";